var fullImageWithSlider = {};
fullImageWithSlider.init = function () {
  fullImageWithSlider.slider();
};
fullImageWithSlider.slider = function () {
  var slider = $('.js-full-image-with-slider');
  if (slider.length === 0) {
    return;
  }
  $.each(slider, function () {
    var $slider = $(this);
    var sliderLength = $slider.find('.item').length;
    var flkty = $slider.flickity({
      cellAlign: sliderLength > 1 ? 'left' : 'center',
      contain: true,
      prevNextButtons: true,
      wrapAround: false,
      pageDots: false,
      dragThreshold: 10,
      on: {
        ready: function ready() {
          if (sliderLength == 1) {
            $slider.addClass('flickity-oneSlide');
          } else if (sliderLength == 2) {
            $slider.addClass('flickity-twoSlide');
          }
          var sliderCollapse = $slider.closest('.collapse');
          var headerHeight = $('.js-header').height();
          if (document.body.classList.contains('admin-bar')) {
            if (matchMedia('screen and (min-width: 783px)').matches) {
              headerHeight = $('.js-header').height() + 32;
            } else {
              headerHeight = $('.js-header').height() + 46;
            }
          }
          sliderCollapse.on('shown.bs.collapse', function () {
            flkty.flickity('resize');
            var fullImageWrapper = $(this).parent('.full-image-wrapper');
            var fullImageContent = fullImageWrapper.find('.full-image-content');
            $('html, body').animate({
              scrollTop: fullImageContent.offset().top - (headerHeight + 8)
            }, 1000);
          });
          sliderCollapse.on('hidden.bs.collapse', function () {
            flkty.flickity('resize');
          });
        }
      }
    });
  });
};
fullImageWithSlider.init();
window.fullImageWithSlider = fullImageWithSlider;


// WEBPACK FOOTER //
// ./scripts/components/sliders/interstellar/full-image-with-slider.js